import { Role } from "tree-wallet-client";

export const IMPERSONATION_INDEX = 'tw_impersonate';

interface ImpersonationData {
  user: string;
}

export function arrayHasRole(roles: string[], targetRole: string): boolean {
  return roles.indexOf(targetRole) > -1;
}

export function getRoleFromArray(targetRole: string, rolesReference: Role[]): Role|undefined {
  try {
    for (const role in rolesReference) {
      const currentRole = rolesReference[role];
      if (currentRole.name === targetRole) {
        return currentRole;
      }
    }
    return undefined;
  } catch (err) {
    throw new Error('could not find role ' + targetRole);
  }
}

export function isImpersonating(): boolean {
  const data = getImpersonationData();
  return !!data && !!data.user;
}

export function getImpersonationData(): ImpersonationData|undefined {
  try {
    const storedData = localStorage.getItem(IMPERSONATION_INDEX);
    return storedData ? JSON.parse(storedData) : undefined;
  } catch (err) {
    return undefined;
  }
}

export function setImpersonationData(data: any) {
  // Store the current path before impersonation if this is the first time
  if (!localStorage.getItem(IMPERSONATION_INDEX)) {
    localStorage.setItem('pre_impersonation_path', window.location.pathname);
  }
  return localStorage.setItem(IMPERSONATION_INDEX, JSON.stringify(data));
}

export function stopImpersonation() {
  // The switch only lives on the device: the API keeps no impersonation state, so the exit is local

  // Restore the admin user data if it exists
  const adminUser = localStorage.getItem('admin_user');
  if (adminUser) {
    try {
      localStorage.setItem('me', JSON.stringify(JSON.parse(adminUser)));
    } catch (e) {
      console.error('Error parsing admin user data:', e);
    }
  } else {
    // No admin copy on the device: dropping `me` makes the boot read it again with the admin token
    localStorage.removeItem('me');
  }

  // Get the pre-impersonation path or default to admin users page
  const preImpersonationPath = localStorage.getItem('pre_impersonation_path') || '/admin/users';

  // Clean up impersonation data
  localStorage.removeItem(IMPERSONATION_INDEX);
  localStorage.removeItem('pre_impersonation_path');
  localStorage.removeItem('admin_user');

  // Force a full page reload to ensure all context is reset
  window.location.href = preImpersonationPath;
}
